import React from 'react';
import { SectionTag } from './SectionTag';
import { HOW_STEPS } from './salesData';

/** Cómo funciona: buscar la situación, copiar el mensaje y enviar. */
export function HowItWorksSection() {
  return <section className="w-full bg-mist py-16 sm:py-20" data-id="element-116" data-mp="ui50dnbc0if7">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6" data-id="element-117" data-mp="ujoi7icmz1j3">
        <div className="max-w-2xl" data-id="element-118" data-mp="pk3gj0630f2o">
          <SectionTag data-id="element-119" data-mp="pl4updie9hom">Cómo funciona</SectionTag>
          <h2 className="mt-4 font-display text-[1.85rem] font-extrabold leading-tight text-ink sm:text-[2.4rem]" data-id="element-120" data-mp="1u97ktovvanp">
            Buscá la situación, copiá el mensaje, enviá
          </h2>
        </div>

        <ol className="mt-8 grid gap-3 sm:grid-cols-3" data-id="element-121" data-mp="auxkfl2jj4z0">
          {HOW_STEPS.map(step => <li key={step.num} className="rounded-2xl border border-fog bg-white p-5" data-id="element-122" data-mp="6r7zd5l2r5iq">
              <span className="font-display text-[0.72rem] font-bold tracking-[0.12em] text-wa-deep" data-id="element-123" data-mp="1m8i3vvlt5702">
                {step.num}
              </span>
              <h3 className="mt-2 font-display text-[1.05rem] font-bold leading-snug text-ink" data-id="element-124" data-mp="1i9ithvhb4i18">
                {step.title}
              </h3>
              <p className="mt-1.5 font-sans text-[0.88rem] leading-relaxed text-slate" data-id="element-125" data-mp="1197tnh4b028e">
                {step.desc}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}